export default __webpack_public_path__ + "static/media/alarm.50184cc3.mp3";